let counter = 0;

/**
 * Monotonic, per-session unique id for wiring ARIA relationships (`aria-controls`,
 * `aria-labelledby`, `aria-activedescendant`, listbox/option and tab/tabpanel ids). It started in
 * the in-house form controls and is not limited to them — any widget that has to name a sibling by
 * id needs one that no second instance of the same widget can claim.
 * Not cryptographic — just stable and collision-free within a page.
 */
export function nextAdminuiId(prefix: string): string {
  return `${prefix}-${++counter}`;
}
